import google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb';

export const requestGoogleProtobuf = new google_protobuf_empty_pb.Empty();